import { useCallback } from 'react';
import { useHistory } from 'react-router';

export const useSetFilters = () => {
    const { location, push } = useHistory();

    return useCallback(
        (data) => {
            const searchParams = new URLSearchParams(location.search);
            const prevParams = Object.fromEntries(searchParams);
            const newParams = { ...prevParams, ...data }
            for (const query in newParams){
                if (!newParams[query] && newParams[query] !== 0){
                    delete newParams[query];
                }
            }
            const URLParams = new URLSearchParams(newParams);
            push({ search: URLParams.toString() });
        },
        [location, history]
    );
};
